/* Local-currency estimates only. Shopify product values and checkout stay AUD. */
(() => {
  const start = () => {
    const bar = document.querySelector('[data-mc-display-currency]');
    if (!bar || bar.dataset.initialized || bar.dataset.baseCurrency !== 'AUD') return;
    bar.dataset.initialized = 'true';
    const select = bar.querySelector('select');
    const countries = window.MannatsCountryCurrencies || {};
    const rates = window.Currency?.rates || {};
    const usable = code => Number.isFinite(rates[code]) && rates[code] > 0;
    if (!usable('AUD') || !countries.AU) {
      select.title = 'AUD — local currency estimates are temporarily unavailable.';
      return;
    }
    const choiceKey = 'mc-display-country-v1';
    let currency = 'AUD', selectedCountry = 'AU', userChanged = false, scheduled = false;
    const history = new WeakMap();
    const selector = '.money,.price-item,.money-subtotal,.mc-product-price,.price,.sticky-price,.cart-total-value,.previewCartTotals-value,.previewCartItem-price,.before-discount-price,.discounted-price,[data-item-final-price-display],[data-item-original-price-display],[data-item-price-with-quantity-display],[data-original-price-display],[data-current-price-display],.unit-price,.productView-subtotal,.previewCartItem-saving-price,.free-shipping-message,.shipping-message';
    const excluded = 'script,style,textarea,input,select,option,template,price-range,[data-mc-display-currency],[data-mc-checkout-note],[data-mc-filter-note]';
    const pattern = /(?:A\$|AU\$|\$)\s*(\d[\d,]*(?:\.\d{1,2})?)(?:\s*AUD)?|\bAUD\s*(\d[\d,]*(?:\.\d{1,2})?)/g;
    const formatter = code => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: code, currencyDisplay: 'code' });
    let format = formatter(currency);
    const renderText = original => currency === 'AUD' ? original : original.replace(pattern, (_, first, second) => {
      const amount = Number((first || second).replace(/,/g, ''));
      return format.format(amount * rates.AUD / rates[currency]);
    });
    const scan = () => {
      scheduled = false;
      const visited = new Set();
      document.querySelectorAll(selector).forEach(element => {
        if (element.closest(excluded)) return;
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (visited.has(node) || node.parentElement?.closest(excluded)) continue;
          visited.add(node);
          let entry = history.get(node);
          if (!entry || node.nodeValue !== entry.last) entry = { original: node.nodeValue, last: node.nodeValue };
          const rendered = renderText(entry.original);
          if (node.nodeValue !== rendered) node.nodeValue = rendered;
          entry.last = rendered;
          history.set(node, entry);
        }
      });
      document.querySelectorAll('[name="checkout"],a[href*="/checkout"]').forEach(button => {
        if (!button.parentElement) return;
        let reminder = button.parentElement.querySelector('[data-mc-checkout-note]');
        if (!reminder) {
          reminder = document.createElement('p');
          reminder.dataset.mcCheckoutNote = 'true';
          reminder.className = 'mc-checkout-currency-note';
          button.insertAdjacentElement('afterend', reminder);
        }
        const message = currency === 'AUD' ? 'Checkout is charged in AUD.' : 'Prices shown in ' + currency + ' are estimates. Checkout is charged in AUD.';
        if (reminder.textContent !== message) reminder.textContent = message;
      });
      document.querySelectorAll('price-range').forEach(range => {
        if (range.querySelector('[data-mc-filter-note]')) return;
        const label = document.createElement('p');
        label.dataset.mcFilterNote = 'true';
        label.className = 'mc-checkout-currency-note';
        label.textContent = 'Price filter amounts are in AUD.';
        range.prepend(label);
      });
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(scan); } };
    const entries = Object.entries(countries).sort((a, b) => a[1].name.localeCompare(b[1].name));
    const fragment = document.createDocumentFragment();
    entries.forEach(([code, country]) => {
      const option = document.createElement('option');
      option.value = code;
      option.textContent = country.name + ' · ' + (usable(country.currency) ? country.currency : 'AUD');
      fragment.append(option);
    });
    select.replaceChildren(fragment);
    const setCountry = code => {
      if (!countries[code]) return false;
      selectedCountry = code;
      currency = usable(countries[code].currency) ? countries[code].currency : 'AUD';
      format = formatter(currency);
      select.value = code;
      select.title = countries[code].name + ' · ' + currency;
      scan();
      return true;
    };
    select.addEventListener('change', () => {
      userChanged = true;
      if (setCountry(select.value)) {
        try { localStorage.setItem(choiceKey, JSON.stringify({ country: selectedCountry, expires: Date.now() + 30 * 86400000 })); } catch (_) {}
      }
    });
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    let remembered;
    try { remembered = JSON.parse(localStorage.getItem(choiceKey) || 'null'); } catch (_) {}
    if (remembered && !countries[remembered.country]) {
      try { localStorage.removeItem(choiceKey); } catch (_) {}
      remembered = null;
    }
    if (remembered?.expires > Date.now() && setCountry(remembered.country)) return;
    setCountry(countries[bar.dataset.baseCountry] ? bar.dataset.baseCountry : 'AU');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    fetch((window.Shopify?.routes?.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true', { signal: controller.signal })
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        const detected = data?.detected_values?.country?.handle;
        if (!userChanged && detected) setCountry(detected);
      })
      .catch(() => {})
      .finally(() => clearTimeout(timeout));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
